import StatusValidacao from '../components/avaliacaoInstitucional/StatusValidacao.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

/*  tutoriais */
//import tutorialInstituicaoMain from "./../components/tutoriais/ambienteinstituicao/main.vue";
import HomeAvaliacao from '../components/HomeAvaliacao.vue';
import HomeMain from './../components/HomeMain.vue';
import initPage from './../components/initPage.vue';
import Login from '../components/acesso/LoginAcesso.vue';
import RecuperarSenha from '../components/acesso/RecuperarSenha.vue';
import AlterarSenha from '../components/acesso/AlterarSenha.vue';
import questionarios from '../components/avaliacaoInstitucional/questionarios.vue';
import QuestionariosDisponiveis from '../components/avaliacaoInstitucional/QuestionariosDisponiveis.vue';
import ConfigurarQuestionario from '../components/admin/ConfigurarQuestionario.vue';
import EditarQuestionario from '../components/admin/EditarQuestionario.vue';
import AvaliacaoInstitucional from '../components/AvaliacaoInstitucional.vue';
import Dadospessoais from '../components/servidor/Dadospessoais.vue';
import perfilUsuario from '../components/servidor/PerfilUsuario.vue';
import BancoHoras from '../components/servidor/BancoHoras.vue';
import dadosInscricao from '../components/remocao/inscricao/dadosinscricao/DadosInscricao.vue';
import SelecionarInstrumentoQuestionario from '../components/admin/SelecionarInstumentoQuestionario.vue';

const routes = [
  {
    path: '/home-avaliacao',
    name: 'homeAvaliacao',
    component: HomeAvaliacao,
  },
  {
    path: '/home-main',
    name: 'homeMain',
    component: HomeMain,
  },
  {
    path: '/status-validacao',
    name: 'StatusValidacao',
    component: StatusValidacao,
  },
  {
    path: '/',
    name: 'initPage',
    component: initPage,
    alias: '/initPage',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/recuperar-senha',
    name: 'RecuperarSenha',
    component: RecuperarSenha,
  },
  {
    path: '/alterar-senha',
    name: 'AlterarSenha',
    component: AlterarSenha,
  },
  {
    path: '/questionarios-disponiveis',
    name: 'QuestionariosDisponiveis',
    component: QuestionariosDisponiveis,
  },
  {
    path: '/questionario',
    name: 'questionario',
    component: questionarios,
  },
  {
    path: '/configurar-questionario',
    name: 'ConfigurarQuestionario',
    component: ConfigurarQuestionario,
  },
  {
    path: '/editar-questionario',
    name: 'EditarQuestionario',
    component: EditarQuestionario,
    props: (route) => ({ questionario: route.params.questionario }),
  },
  {
    path: '/avaliacao-institucional',
    name: 'AvaliacaoInstitucional',
    component: AvaliacaoInstitucional,
  },
  {
    path: '/processo-remocao-lotacao',
    name: 'ProcessoRemocaoLotacao',
    component: () => import('../components/remocao/processoAberto.vue'),
  },
  {
    path: '/remocao-pre-inscricao',
    name: 'ProcessoRemocaoPreInscricao',
    component: () => import('../components/remocao/inscricao/preInscricao.vue'),
  },
  {
    path: '/remocao-confirmar-inscricao',
    name: 'ConfirmarInscricao',
    component: () => import('../components/remocao/inscricao/ConfimarInscricao.vue'),
  },
  {
    path: '/dados-pessoais',
    name: 'Dadospessoais',
    component: Dadospessoais,
  },
  {
    path: '/perfil-usuario',
    name: 'perfilUsuario',
    component: perfilUsuario,
  },
  {
    path: '/banco-horas',
    name: 'BancoHoras',
    component: BancoHoras,
  },
  {
    path: '/remocao-dados-inscricao',
    name: 'DadosInscricao',
    component: dadosInscricao,
  },
  {
    path: '/validar-usuario-questionario',
    name: 'ValidaUsuarioQuestionario',
    component: () => import('@/components/avaliacaoInstitucional/ValidaUsuarioQuestionario.vue'),
  },
  {
    path: '/selecionar-instrumento-questionario',
    name: 'SelecionarInstrumentoQuestionario',
    component: SelecionarInstrumentoQuestionario,
  },
  {
    path: '/editor-questionario',
    name: 'EditorQuestionario',
    component: () => import('@/components/admin/EditarQuestionarioForm.vue'),
  },
  {
    path: '/editor-questoes',
    name: 'EditorQuestoes',
    component: () => import('@/components/admin/EditarQuestionarioQuestoes.vue'),
  },

  {
    path: '/avaliacao-servidor',
    name: 'pageAvaliacaoServidor',
    component: () => import('@/components/servidor/PageAvaliacaoServidor.vue'),
  },
  {
    path: '/avaliacao-servidor-comentario',
    name: 'ComentarioAvaliacao',
    component: () => import('@/components/avaliacaoInstitucional/ComentarioAvaliacao.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: routes,
});

// Tratamento de erro global para navegação duplicada
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

export default router;
